import { render, staticRenderFns } from "./FromInput.vue?vue&type=template&id=b73a555a&scoped=true&"
import script from "./FromInput.vue?vue&type=script&lang=js&"
export * from "./FromInput.vue?vue&type=script&lang=js&"
import style0 from "./FromInput.vue?vue&type=style&index=0&id=b73a555a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73a555a",
  null
  
)

export default component.exports